import React from "react";
import { Dropdown } from "react-bootstrap";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import { Link } from "react-router-dom";
import ExpensesTable from "../../components/Tables/ExpensesTable";
import withPermissions from "../../components/WithPermissions";
import ManagementPageHero from "../../components/ManagementPageHero";

class Expenses extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const {userPermissions} = this.props;
    const userHasNewExpensePermission = userPermissions.includes('new expense');
    return (
      <div
        className="management-page"
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="container-fluid">
            <PageHeader
                HeaderText="Giderler"
                Breadcrumb={[
                  {name: "Gelir ve Giderler", navigate: ""},
                  {name: "Giderler", navigate: ""},
                ]}
            />
            <ManagementPageHero
              eyebrow="GİDER TAKİBİ"
              title="Giderlerinizi kontrol altında tutun"
              description="İşletme giderlerini düzenli takip edin, kategori ve tarih bazında kayıtlarınıza ulaşın."
              actionTo={userHasNewExpensePermission ? "/expense-add" : null}
              actionLabel="Yeni gider"
            />
            <div className="row clearfix">
              <div className="col-lg-12 col-md-12">
                <div className="card planned_task management-list-card">
                  <div className="header">
                    <h2>Giderler</h2>
                    {userHasNewExpensePermission ? (
                        <Dropdown as="ul" className="header-dropdown">
                          <Dropdown.Toggle
                              variant="success"
                              as="li"
                              id="dropdown-basic"
                          >
                            <i className="icon-plus text-success p-1 ml-1"></i>
                            <Dropdown.Menu
                                as="ul"
                                className="dropdown-menu dropdown-menu-right"
                            >
                              <li>
                                <Link to="/expense-add">Yeni Gider</Link>
                              </li>

                            </Dropdown.Menu>
                          </Dropdown.Toggle>
                        </Dropdown>
                    ) : ""}

                  </div>
                  <div className="body">
                    <ExpensesTable>

                    </ExpensesTable>
                  </div>
                </div>
              </div>
            </div>
            <style>
              {`
                #dropdown-basic::after {
                    display: none;                                                     
                }
              `}
            </style>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ioTReducer}) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(connect(mapStateToProps, {})(Expenses));
